import { AppIcon } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import { openCustomTab } from '@backrs_ui/grow-ui/src/redux/tabs/tabs.slice';

import { Button, SxProps, Theme } from '@mui/material';

import { ExploreTradeoffsCard } from '../ExploreTradeoffsCard';

const SECTION_STRINGS = appStrings.modules.survey.output.blueprintSection;

export function ExploreTradeoffsTrigger() {
  const dispatch = useAppDispatch();

  return (
    <ExploreTradeoffsCard
      title={SECTION_STRINGS.exploreTradeoffsCard.collapsed.title}
      description={SECTION_STRINGS.exploreTradeoffsCard.collapsed.description}
      belowAction={
        <Button
          id="blueprint-explore-tradeoffs-card-btn"
          hierarchy="Secondary gray"
          size="md"
          icon="Leading"
          startIcon={
            <AppIcon
              iconName="SwitchHorizontal01"
              diameter="20px"
              color="Colors/Foreground/fg-secondary"
            />
          }
          onClick={() => dispatch(openCustomTab('tradeoffs'))}
          sx={triggerBtnSx}
        >
          {SECTION_STRINGS.exploreTradeoffs}
        </Button>
      }
    />
  );
}

const triggerBtnSx: SxProps<Theme> = {
  alignSelf: 'stretch',
  '@container (min-width: 600px)': {
    alignSelf: 'auto',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
};
